const noDecimalCurrencies = ['IDR', 'THB', 'MYR', 'PHP']

const calcExportPrice = (
  price,
  rate,
  round,
  chargePercentage = 10
) => {
  const priceWithCharge = price + ((price * chargePercentage) / 100)
  const convertedPrice = priceWithCharge / rate
  const dividedByRound = Math.round(convertedPrice / round)
  const finalPrice = dividedByRound * round
  return Number(finalPrice).toFixed(2)
}

export const showPriceLocale = (number, locale, currency) => {
  const formatter = new Intl.NumberFormat(`en-${locale}`, {
    style: 'currency',
    currency
  })
  const parts = formatter.formatToParts(number)
  const currencySymbol = parts.find((p) => p.type === 'currency')?.value || ''

  const fractionDigits = noDecimalCurrencies.includes(currency) ? 0 : 2

  const normalizedPrice = Number(number).toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    useGrouping: true
  })

  return {
    currency: currencySymbol,
    price: normalizedPrice
  }
}

export const mapProductExportCurrencyPrice = (
  inputProduct,
  currencyRate,
  chargePercentage = 10,
  conversionPrices = []
) => {
  const product = { ...inputProduct }
  let price = product?.originalPrice || product.price
  const priceHasMapping = conversionPrices.find((priceMapping) => priceMapping.thb === price && priceMapping.currency === currencyRate.currency)

  if (priceHasMapping) {
    price = priceHasMapping.value
  } else {
    price = calcExportPrice(
      product?.originalPrice || product.price,
      currencyRate.value,
      currencyRate.round,
      chargePercentage
    )
  }
  return {
      priceFromMapping: priceHasMapping !== undefined,
      price,
      currency: currencyRate.currency,
      locale: currencyRate.country
  }
}
